import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { numberToFormattedCount } from '../../../../../models/UiUtils';
import { Tag } from '../../../../components/tags/Tag';
import { baseStyleSheet } from '../../../../styles/styles';
import { useCompaniesSearch } from '../CompaniesContext';
import { styleSheet } from './styles';

export const CompaniesSearchDescription: React.FC = observer(() => {
	const { filter, companiesQuery } = useCompaniesSearch();

	const search =
		filter.criteria?.find(x => x.property === Api.CompanySearchRequestProperty.Name)?.value ??
		filter.criteria?.find(x => x.property === Api.CompanySearchRequestProperty.All)?.value ??
		'';

	const tag = filter.criteria?.find(x => x.property === Api.CompanySearchRequestProperty.Tag)?.value;

	const totalCount = companiesQuery?.data?.pages[0].totalCount ?? 0;

	return (
		<div className={css(styleSheet.container)}>
			<span className={css(baseStyleSheet.fontBold)}>{numberToFormattedCount(totalCount)}</span>
			&nbsp;
			{totalCount === 1 ? 'company' : 'companies'}
			&nbsp;
			{!!search && (
				<span>
					{' for "'}
					<span className={css(baseStyleSheet.fontBold)}>{search + '"'}</span>
					&nbsp;
				</span>
			)}
			{!!tag && (
				<span className={css(styleSheet.tag)}>
					{' with the tag '}
					&nbsp;
					<Tag tagValue={tag} />
					&nbsp;
				</span>
			)}
		</div>
	);
});
